import FieldConfig from "../../../../fields3/proto/field-config";
import FieldTask from "../../../generic/task/task";
import ImportFromCSVModule from "../../../../gd-modules/import-from-csv/import-from-csv-module";
import FieldTaskParentTask_CSVImportPreview from "./render/csv-import-preview";

export default class FieldTaskParentTask extends FieldTask {

    FIELD_DEFAULT_WIDTH = 250;

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel      = "Parent task";
        this.icon           = 'ii5-task';

        this.variableName   = '{TASK-PARENT-TASK}'


        this.renderComponents.csvImportPreview  = FieldTaskParentTask_CSVImportPreview
    }


    // is used to convert value for import from CSV - can be redefined in specific cases
    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {

        // const selfReferenceUID = _.get(module.selfReferenceMap, value, null)
        const selfReferenceUID = module.selfReferenceMap[value]

        return selfReferenceUID
    }

}
